    <header class="page-head">
      <div>
        <h1 class="page-title">Check Out</h1>
        <p class="page-subtitle">Finalize payment for selected services and confirm the billing profile to use.</p>
      </div>
    </header>

    <section class="detail-grid">
      <div class="detail-card span-7">
        <form class="form-stack" [formGroup]="checkoutForm">
          <div class="input-group">
            <label>Order summary</label>
            <textarea formControlName="orderSummary"></textarea>
          </div>
          <div class="input-group">
            <label>Billing email</label>
            <input formControlName="billingEmail" />
          </div>
          <div class="input-group">
            <label>Payment method</label>
            <select formControlName="paymentMethod">
              <option value="saved-card">Saved card</option>
              <option value="new-card">New card</option>
              <option value="eft">EFT</option>
            </select>
          </div>
          <button class="btn btn-primary" type="button">Finalize payment</button>
        </form>
      </div>

      <aside class="detail-card span-5">
        <h2 class="section-title">Total due</h2>
        <p class="label">Priority institution update pack: R149.00</p>
        <p class="label">Enhanced contact vault: R79.00</p>
        <strong class="total-due-amount">R228.00</strong>
      </aside>
    </section>
